module.exports = __webpack_public_path__ + "static/media/delete-icon.25a53701.svg";